import { CHART_MAX_SERIES, CHART_PALETTE } from './chart-tokens';

const clampSeriesCount = (seriesCount: number): 1 | 2 | 3 => {
  if (seriesCount <= 1) return 1;
  if (seriesCount >= CHART_MAX_SERIES) return 3;

  return 2;
};

/** Picks the swatch color for a series at a given ramp position. */
export const colorForSeries = (
  seriesIndex: number,
  seriesCount: number
): string => {
  const ramp = CHART_PALETTE[clampSeriesCount(seriesCount)];

  return ramp[seriesIndex % ramp.length];
};
